module.exports = __webpack_public_path__ + "img/outlander2022_base.710ce15c.jpg";